import { CheckboxCard } from '@design-system';

import { ProductPrice } from '../../../ProductPrice/ProductPrice';
import { CurrencyCode } from '../types';

export interface GlazingOptionProps {
  groupName: string;
  glazing: string;
  checked: boolean;
  /** Price difference versus the currently selected glazing (0 → no suffix). */
  priceDelta: number;
  currencyCode?: CurrencyCode;
  isFloat?: boolean;
  /** Optional feature bullet points for this glazing. */
  features?: string[];
  onSelect: () => void;
}

export const GlazingOption = ({
  checked,
  currencyCode,
  features,
  glazing,
  groupName,
  isFloat = false,
  onSelect,
  priceDelta,
}: GlazingOptionProps) => {
  const showPrice = !checked && priceDelta !== 0;

  return (
    <CheckboxCard
      checked={checked}
      features={features}
      id={`${groupName}-${encodeURIComponent(glazing)}`}
      label={glazing}
      name={groupName}
      onChange={onSelect}
      suffix={
        showPrice ? (
          <ProductPrice
            currencyCode={currencyCode}
            isFloat={isFloat}
            prefix={priceDelta >= 0 ? '+' : '-'}
            price={Math.abs(priceDelta)}
            skipConvertCurrency={!!currencyCode}
            skipTaxCalculation
          />
        ) : undefined
      }
      type="radio"
      value={glazing}
    />
  );
};
